import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchInput", "workflowRow", "assignmentBadge", "assignmentButton", "assignedCount", "statusMessage"]

  static values = {
    createUrl: String,
    destroyUrl: String,
    userId: Number,
  }

  connect() {
    this.filter()
  }

  filter() {
    const query = this.hasSearchInputTarget ? this.searchInputTarget.value.trim().toLowerCase() : ""

    this.workflowRowTargets.forEach((row) => {
      const name = row.dataset.name || ""
      const show = query === "" || name.includes(query)
      row.classList.toggle("d-none", !show)
    })
  }
  async toggleAssignment(event) {
    const button = event.currentTarget
    const row = button.closest('[data-app-configuration-id]')
    if (!row) return

    const pairId = row.dataset.pairId
    if (pairId) {
      await this._remove(row, button, parseInt(pairId, 10))
    } else {
      await this._assign(row, button, parseInt(row.dataset.appConfigurationId, 10))
    }
  }

  async _assign(row, button, appConfigurationId) {
    this._setPending(button, "Assigning…")

    try {
      const response = await fetch(this.createUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": this._csrf(),
        },
        body: JSON.stringify({
          app_configuration_id: appConfigurationId,
          user_id: this.userIdValue,
        }),
      })

      const data = await response.json()
      if (!response.ok || !data.success) throw new Error(data.error || `HTTP ${response.status}`)

      row.dataset.pairId = data.pair_id
      this._setAssignedState(row, true)
      this._flash(`Assigned workflow to ${data.user_name}.`)
    } catch (error) {
      this._flash(error.message, true)
    }
  }

  async _remove(row, button, pairId) {
    this._setPending(button, "Removing…")

    try {
      const response = await fetch(`${this.destroyUrlValue}/${pairId}`, {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": this._csrf(),
        },
      })

      const data = await response.json()
      if (!response.ok || !data.success) throw new Error(data.error || `HTTP ${response.status}`)

      delete row.dataset.pairId
      this._setAssignedState(row, false)
      this._flash(`Removed ${data.workflow_name || "workflow"} assignment.`)
    } catch (error) {
      this._flash(error.message, true)
    }
  }

  _setAssignedState(row, assigned) {
    const badge = row.querySelector('[data-user-workflows-target="assignmentBadge"]')
    const button = row.querySelector('[data-user-workflows-target="assignmentButton"]')

    badge.textContent = assigned ? "Assigned" : "Available"
    badge.className = `badge ${assigned ? "text-bg-success" : "text-bg-light border"}`

    button.disabled = false
    button.textContent = assigned ? "Remove" : "Assign"
    button.className = `btn btn-sm ${assigned ? "btn-outline-danger" : "btn-outline-primary"}`

    const assignedRows = this.workflowRowTargets.filter((workflowRow) => workflowRow.dataset.pairId).length
    this.assignedCountTarget.textContent = assignedRows
  }

  _setPending(button, label) {
    button.disabled = true
    button.textContent = label
  }

  _flash(message, isError = false) {
    this.statusMessageTarget.textContent = message
    this.statusMessageTarget.classList.toggle("text-danger", isError)
    this.statusMessageTarget.classList.toggle("text-success", !isError)
  }

  _csrf() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }
}
